import React from 'react';
import { Box, Stack, Typography, Grid, Button } from '@mui/material';
import ProfileWelcomeImage from '../../../assests/images/profile_welcome_image.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function WelcomePage({ handleTeamSetupClick, userDetails }) {
  return (
    <Stack gap="24px" sx={{ padding: '27px 32px', width: '100%' }}>
      <Box>
        <Stack direction="column" gap="8px">
          <Typography variant="h4">PO Teams</Typography>
        </Stack>
      </Box>
      <Grid container>
        <Grid item xs sx={{ height: '100%' }}>
          <Stack
            direction="row"
            gap={2}
            sx={{
              height: '100%'
            }}>
            <Box
              gap={2}
              sx={{
                p: 2,
                height: '100%'
              }}>
              <img src={ProfileWelcomeImage} alt={'profile'} width={580} height={392} />
            </Box>
            <Stack>
              <Typography
                variant="h4"
                fontWeight="500">{`Hi ${userDetails.username || ''}!`}</Typography>
              <Typography variant="p" fontWeight="500">
                Looks like you haven’t set up your teams yet.
                <br />
                It’s really simple! Just let us know what business unit <br />
                and function you’re in.
              </Typography>
              <Button
                sx={{ width: '160px', mt: 2 }}
                size="small"
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIcon />}
                fullWidth
                onClick={() => handleTeamSetupClick()}>
                Set Up Profile
              </Button>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
}
